import boxopenfly from "./riveArchive/boxopenfly.riv";
import free from "./riveArchive/free.riv";
import nofound from "./riveArchive/Nofound.riv";

import createjob from "./riveArchive/createjob.riv";
import home from "./riveArchive/home.riv";
import layout from "./riveArchive/layout.riv";
import sectorworkflow from "./riveArchive/sectorworkflow.riv";
import timesheets from "./riveArchive/timesheets.riv";

type RiveInput = { type: "number"; value: number } | { type: "boolean"; value: boolean } | { type: "trigger" };
type RiveEntry =
  | {
      file: string;
      stateMachine: string;
      inputs?: Record<string, RiveInput>;
    }
  | {
      file: string;
      animations: string[];
    };

type RiveRegistry = "notFound" | "free" | "createjob" | "boxopenfly" | "home" | "layout" | "sectorworkflow" | "timesheets";

const riveRegistry: Record<RiveRegistry, RiveEntry> = {
  notFound: {
    file: nofound,
    animations: ["Animation 1"],
  },
  free: {
    file: free,
    stateMachine: "State Machine 1",
  },

  boxopenfly: {
    file: boxopenfly,
    stateMachine: "State Machine 1",
  },

  // entradas reales ( file es el nombre del archivo .riv, stateMachine es el nombre de la state machine dentro del archivo .riv, debe de ir con el prefijo sm-nombre del archivo, inputs es un objeto con las entradas de la state machine )
  createjob: {
    file: createjob,
    stateMachine: "sm-createjob",
  },
  home: {
    file: home,
    stateMachine: "sm-home",
  },
  layout: {
    file: layout,
    stateMachine: "sm-layout",
  },
  sectorworkflow: {
    file: sectorworkflow,
    stateMachine: "sm-sectorworkflow",
  },
  timesheets: {
    file: timesheets,
    stateMachine: "sm-timesheets",
  },
};

export type RiveRegistryKey = keyof typeof riveRegistry;

export { riveRegistry };
